import { ListEntityType } from "../../enums/list-entity-type";
import { CardTracker } from "./card-tracker";
export class StudyCardTracker extends CardTracker {
    constructor(tracker) {
        super(tracker);
    }
    getListEntityType() {
        return ListEntityType.STUDY;
    }
}
